
import { Link } from 'react-router-dom';

interface ActivationStepCardProps {
  icon: string;
  title: string;
  subtitle: string;
  status: 'completed' | 'locked' | 'available';
  href?: string;
}

export default function ActivationStepCard({
  icon,
  title,
  subtitle,
  status,
  href,
}: ActivationStepCardProps) {
  if (status === 'completed') {
    return (
      <div className="group relative bg-white dark:bg-slate-800 rounded-lg p-4 border border-emerald-200 dark:border-emerald-900/50 flex items-center gap-4 shadow-sm">
        <div className="w-10 h-10 rounded-full bg-emerald-100 dark:bg-emerald-900/30 text-emerald-600 flex items-center justify-center flex-shrink-0">
          <span className="material-symbols-outlined text-xl">check</span>
        </div>
        <div className="flex-grow">
          <h4 className="font-bold text-sm text-slate-900 dark:text-white">{title}</h4>
          <p className="text-xs text-slate-500">{subtitle}</p>
        </div>
      </div>
    );
  }

  if (status === 'available') {
    return (
      <Link
        to={href ?? '#'}
        className="group relative bg-white dark:bg-slate-800 rounded-lg p-4 border border-blue-200 dark:border-blue-900/50 flex items-center gap-4 shadow-sm cursor-pointer hover:border-primary hover:shadow-md transition-all"
      >
        <div className="w-10 h-10 rounded-full bg-blue-50 dark:bg-blue-900/20 text-primary flex items-center justify-center flex-shrink-0">
          <span className="material-symbols-outlined text-xl">{icon}</span>
        </div>
        <div className="flex-grow">
          <h4 className="font-bold text-sm text-slate-900 dark:text-white">{title}</h4>
          <p className="text-xs text-slate-500">{subtitle}</p>
        </div>
        <span className="material-symbols-outlined text-primary text-lg">chevron_right</span>
      </Link>
    );
  }

  return (
    <div className="group relative bg-slate-50 dark:bg-slate-800/30 rounded-lg p-4 border border-slate-100 dark:border-slate-800 flex items-center gap-4 opacity-70 cursor-not-allowed">
      <div className="w-10 h-10 rounded-full bg-slate-200 dark:bg-slate-700 text-slate-400 flex items-center justify-center flex-shrink-0">
        <span className="material-symbols-outlined text-xl">{icon}</span>
      </div>
      <div className="flex-grow">
        <h4 className="font-bold text-sm text-slate-500 dark:text-slate-400">{title}</h4>
        <p className="text-xs text-slate-400">{subtitle}</p>
      </div>
      <span className="material-symbols-outlined text-slate-300 text-lg">lock</span>
    </div>
  );
}
